import { useEffect, useState, type ReactNode } from 'react';
import { CheckCircle2, CloudOff, RefreshCw, AlertTriangle } from 'lucide-react';
import {
  estadoSyncActual,
  onEstadoSync,
  sincronizar,
  type EstadoSync as TEstado,
} from '../lib/sync';

export function EstadoSync() {
  const [estado, setEstado] = useState<TEstado>('idle');
  const [pendientes, setPendientes] = useState(0);

  useEffect(() => {
    const inicial = estadoSyncActual();
    setEstado(inicial.estado);
    setPendientes(inicial.pendientes);
    return onEstadoSync((e, p) => {
      setEstado(e);
      setPendientes(p);
    });
  }, []);

  const onClick = () => {
    void sincronizar();
  };

  if (estado === 'syncing') {
    return (
      <Pildora className="bg-blue-50 text-blue-700 border-blue-200">
        <RefreshCw size={14} className="animate-spin" />
        Sincronizando...
      </Pildora>
    );
  }
  if (estado === 'offline') {
    return (
      <Pildora className="bg-gray-100 text-gray-700 border-gray-200" onClick={onClick}>
        <CloudOff size={14} />
        Sin conexión
        {pendientes > 0 && <span className="ml-1 font-semibold">({pendientes} pendientes)</span>}
      </Pildora>
    );
  }
  if (estado === 'error') {
    return (
      <Pildora className="bg-red-50 text-red-700 border-red-200" onClick={onClick}>
        <AlertTriangle size={14} />
        Error de sync — reintentar
      </Pildora>
    );
  }
  if (pendientes > 0) {
    return (
      <Pildora className="bg-amber-50 text-amber-700 border-amber-200" onClick={onClick}>
        <RefreshCw size={14} />
        {pendientes} cambios por sincronizar
      </Pildora>
    );
  }
  return (
    <Pildora className="bg-green-50 text-green-700 border-green-200">
      <CheckCircle2 size={14} />
      Sincronizado
    </Pildora>
  );
}

function Pildora({
  children,
  className,
  onClick,
}: {
  children: ReactNode;
  className: string;
  onClick?: () => void;
}) {
  const base = `inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full border ${className}`;
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={`${base} hover:opacity-90 cursor-pointer`}>
        {children}
      </button>
    );
  }
  return <span className={base}>{children}</span>;
}
